import React, { useEffect, useState } from 'react';
import { Grid, TextField } from '@material-ui/core';
import { ResourceDto } from '../resources.dtos';
import {
  FormikErrors,
  FormikHandlers,
  FormikHelpers,
  FormikTouched,
} from 'formik';
import { DocumentTypesEnum_class } from '../../../../../../common/enums/documentTypes';

interface IProps {
  values: ResourceDto;
  errors: FormikErrors<ResourceDto>;
  touched: FormikTouched<ResourceDto>;
  handleChange: FormikHandlers['handleChange'];
  handleBlur: FormikHandlers['handleBlur'];
  setFieldValue: FormikHelpers<ResourceDto>['setFieldValue'];
}

const ResourceUpdateForm: React.FC<IProps> = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
}) => {
  const [readOnly, setReadOnly] = useState(true);
  useEffect(() => {
    if (values.documentTypeId === DocumentTypesEnum_class.enum.URL) {
      setReadOnly(false);
    }
  }, [values]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <TextField
          size='small'
          margin='none'
          value={values.name || ''}
          label='File Name'
          name='name'
          onChange={handleChange}
          onBlur={(e) => {
            handleBlur(e);
          }}
          error={Boolean(errors.name && touched.name)}
          helperText={Boolean(errors.name) && touched.name && errors.name}
          fullWidth
          required
        />
        <TextField
          size='small'
          margin='none'
          value={values.documentType || 'URL'}
          label='Type'
          name='documentType'
          onChange={handleChange}
          onBlur={(e) => {
            handleBlur(e);
          }}
          error={Boolean(errors.documentType && touched.documentType)}
          helperText={
            Boolean(errors.documentType) &&
            touched.documentType &&
            errors.documentType
          }
          fullWidth
          inputProps={{ readOnly: true }}
        />
        <TextField
          size='small'
          margin='none'
          value={values.fileUrl || ''}
          label='URL'
          name='fileUrl'
          onChange={handleChange}
          onBlur={(e) => {
            handleBlur(e);
          }}
          error={Boolean(errors.fileUrl && touched.fileUrl)}
          helperText={
            Boolean(errors.fileUrl) && touched.fileUrl && errors.fileUrl
          }
          fullWidth
          required
          inputProps={{ readOnly: readOnly }}
        />
      </Grid>
    </Grid>
  );
};

export default ResourceUpdateForm;
